import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { prepareWord } from 'src/app/shared/functions/generic-methods';

@Component({
  selector: 'app-add-medications-in-use',
  templateUrl: './add-medications-in-use.component.html',
  styleUrls: ['./add-medications-in-use.component.scss']
})
export class AddMedicationsInUseComponent {
  editingItemIndex: number = -1;
  button: string = 'Incluir';
  commorbitySelected: any;
  medicamento: string = '';
  observacao: string = '';
  via: string = '';

  medicationsInUse: Array<any> = [];

  linhasEmBranco: Array<any> = [];
  finalTable: Array<any> = [];

  observationsCtrl = new FormControl()
  viaCtrl = new FormControl()

  constructor(
    public dialogRef: MatDialogRef<AddMedicationsInUseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    this.includePreviousMedications();
  }

  includePreviousMedications() {
    this.medicationsInUse = this.data.medsInUse ? this.data.medsInUse : [];
    this.fillTableWithEmptyLines();
  }

  fillTableWithEmptyLines() {
    this.linhasEmBranco = new Array(10 - this.medicationsInUse.length).fill('');

    if (this.medicationsInUse.length > 0) {
      this.finalTable = [...this.medicationsInUse, ...this.linhasEmBranco];
    }
    else {
      this.finalTable = [...this.linhasEmBranco];
    }
  }

  getSelectedMedication(event: any) {
    this.medicamento = event;
  }

  includeMedication() {
    if (this.button === 'Atualizar') {
      this.medicationsInUse[this.editingItemIndex] = {
        medicamento: this.medicamento,
        observacao: this.observationsCtrl.value,
        via: this.viaCtrl.value
      };
    }
    else {
      this.medicationsInUse.push({
        medicamento: this.medicamento,
        observacao: this.observationsCtrl.value,
        via: this.viaCtrl.value
      });
    }

    this.fillTableWithEmptyLines();

    this.observacao = '';
    this.medicamento = '';
    this.via = ''

    this.observationsCtrl.setValue('');
    this.viaCtrl.setValue('');

    this.button = 'Incluir';
  }

  editSelectedMedication(itemSelected: any) {
    this.editingItemIndex = this.medicationsInUse.findIndex(f => prepareWord(f.medicamento) === prepareWord(itemSelected.medicamento));
    this.medicamento = itemSelected.medicamento;
    this.observacao = itemSelected.observacao;
    this.via = itemSelected.via;

    this.observationsCtrl.setValue(itemSelected.observacao);
    this.viaCtrl.setValue(itemSelected.via);

    this.button = 'Atualizar';
  }

  deleteMedication(meds: any) {
    this.medicationsInUse = this.medicationsInUse.filter(item => item.medicamento !== meds.medicamento);
    this.fillTableWithEmptyLines();
  }

  save() {
    this.dialogRef.close({ type: 'save', medicationsInUse: this.medicationsInUse });
  }

  close() {

    this.dialogRef.close({ type: 'cancel' });
  }

}